import { useMutation, gql } from '@apollo/react-hooks';
import { useCallback } from 'react';
import type { DeleteAttachmentAndCleanRefsMutation } from '#/graphql/types';
import { deleteAttachmentAndCleanRefs } from '#/graphql/mutations';

const q = gql(deleteAttachmentAndCleanRefs);

const useAttachmentDeleteMutation = () => {
  const [mutation, result] = useMutation<DeleteAttachmentAndCleanRefsMutation>(q);
  const deleteAttachment = useCallback(
    (workOrderId: string, relatedField?: string) => {
      return mutation({
        variables: {
          id: workOrderId,
          data: {
            relatedField: relatedField ?? null,
          },
        },
      });
    },
    [mutation],
  );

  return { deleteAttachment, result };
};

export default useAttachmentDeleteMutation;
